import type { Usuario } from '@/types'
import { ROUTE_PATHS } from './routeManifest'

interface AuthNavigationState {
  cargando: boolean
  estaAutenticado: boolean
  usuario: Usuario | null
}

interface AdminNavigationState {
  cargando: boolean
  perfilSincronizado: boolean
  usuario: Usuario | null
}

interface PasswordRecoveryNavigationState {
  event: string
  currentPath: string
}

export function getAuthGuardRedirect({
  cargando,
  estaAutenticado,
  usuario,
}: AuthNavigationState): string | null {
  if (cargando) return null
  if (!estaAutenticado) return ROUTE_PATHS.login
  if (usuario && !usuario.onboarding_completado) return ROUTE_PATHS.onboarding
  return null
}

export function getOnboardingGuardRedirect({
  cargando,
  estaAutenticado,
  usuario,
}: AuthNavigationState): string | null {
  if (cargando) return null
  if (!estaAutenticado) return ROUTE_PATHS.login
  if (usuario?.onboarding_completado) return ROUTE_PATHS.reporte
  return null
}

export function getAdminPageRedirect({
  cargando,
  perfilSincronizado,
  usuario,
}: AdminNavigationState): string | null {
  if (cargando) return null
  if (!usuario) return ROUTE_PATHS.login
  if (!perfilSincronizado) return null
  if (usuario.rol !== 'admin') return ROUTE_PATHS.reporte
  return null
}

export function getPasswordRecoveryRedirect({
  event,
  currentPath,
}: PasswordRecoveryNavigationState): string | null {
  if (event !== 'PASSWORD_RECOVERY') return null
  if (currentPath === ROUTE_PATHS.resetPassword) return null
  return ROUTE_PATHS.resetPassword
}
